import { useLocation } from "react-router-dom";

// TODO: Update this function to accomodate deeper nesting and lookup product name from backned API
export function usePageMeta() {
  const location = useLocation();
  const path = location.pathname;

  // Split the URL path and remove the empty parts.
  // URLs are /store/<handle>/<destination>/..., so the first two segments
  // identify the store rather than the page and are dropped - otherwise every
  // breadcrumb would start with "Store / Zeri".
  const rawSegments = path.split("/").filter(Boolean);
  const segments =
    rawSegments[0] === "store" && rawSegments.length > 1
      ? rawSegments.slice(2)
      : rawSegments;

  const labelMap = {
    admin: "Dashboard",
    products: "Products",
    orders: "Orders",
    customers: "Customers",
    discounts: "Discounts",
    "theme-store": "Theme Store",
    "my-themes": "My Themes",
    settings: "Settings",
    help: "Help & Support",
    "help-support": "Help & Support",
    "account-settings": "Account Settings",
    "new-product": "New Product",
    billing: "Billing",
    payment: "Payment",
  };

  // Convert a URL segment into a readable label
  function prettifySegment(slug) {
    return slug
      .replace(/[-_]/g, " ") // replace dashes/underscores
      .replace(/\b\w/g, (c) => c.toUpperCase()); // capitalize words
  }

  // Convert each segment into a human-readable label
  const breadcrumb = segments.map((seg) => labelMap[seg] || prettifySegment(seg));
  const basePath = "";

  const isBreadcrumbPage = segments.length > 2;
  const pageTitle = breadcrumb[breadcrumb.length - 1] || "Dashboard";

  return {
    mode: isBreadcrumbPage ? "breadcrumb" : "title",
    pageTitle,
    breadcrumb,
    segments,
    basePath,
  };
}